export const SPONSORED_STORE_ID = Number(process.env.VUE_APP_SPONSORED_STORE_ID)
export const SPONSORED_BANNER_ID = Number(
  process.env.VUE_APP_SPONSORED_BANNER_ID
)
